import {useEffect, useState} from "react";
import Loading from "../../../component/Loading/Loading";
import TreeSelect from "../../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../../assets/functions";
import {getAllPeopleDividedByRole} from "../../../component/PersonForm/functions";
import {json} from "react-router-dom";
import {ExceptionPersonFormWithoutContainer} from "../../../component/ExceptionPersonForm/ExceptionPersonForm";

const TransactionFilter = ({searchParams, onSubmit}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [searchForm, setSearchForm] = useState({...searchParams});

    const defaultSearchParams = {
        exceptionPerson: {
            isAllCustomer: "TRUE",
            includeCustomerAreaBlock: [],
            excludeCustomerAreaBlock: [],
            includeCustomerTown: [],
            excludeCustomerTown: [],
            includeCustomerId: [],
            excludeCustomerId: [],
        },
        increaseTransactions : true,
        decreaseTransactions : true,
        verifiedTransactions : true,
        unverifiedTransactions : false,
    }

    const changeSearchForm = (key, value) => {
        setSearchForm({...searchForm, [key]: value});
    }

    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();
    }, []);


    if (isLoading)
        return <Loading/>


    return (
        <div className={"row"}>

            <div className="col-md-3 mt-4">
                <div className="col-12">
                    <ExceptionPersonFormWithoutContainer
                        exceptionPerson={searchForm.exceptionPerson != undefined ? JSON.parse(searchForm.exceptionPerson) : defaultSearchParams.exceptionPerson}
                        onChange={(value) => {
                            changeSearchForm("exceptionPerson", JSON.stringify(value))
                        }}/>
                </div>
            </div>

            <div className="col-md-3 mt-4">
                <div className="mb-1">
                    <input className="form-check-input" type="checkbox" id="increaseTransactions"
                           checked={searchForm.increaseTransactions != undefined ? JSON.parse(searchForm.increaseTransactions) : defaultSearchParams.increaseTransactions}
                           onChange={() => {
                               changeSearchForm("increaseTransactions", searchForm.increaseTransactions != undefined ? !JSON.parse(searchForm.increaseTransactions) : !defaultSearchParams.increaseTransactions)
                           }}/>
                    <label className="form-check-label me-1" htmlFor="increaseTransactions">
                        تراکنش های افزایشی
                    </label>
                </div>
                <div className="mb-1">
                    <input className="form-check-input" type="checkbox" id="decreaseTransactions"
                           checked={searchForm.decreaseTransactions != undefined ? JSON.parse(searchForm.decreaseTransactions) : defaultSearchParams.decreaseTransactions}
                           onChange={() => {
                               changeSearchForm("decreaseTransactions", searchForm.decreaseTransactions != undefined ? !JSON.parse(searchForm.decreaseTransactions) : !defaultSearchParams.decreaseTransactions)
                           }}/>
                    <label className="form-check-label me-1" htmlFor="decreaseTransactions">
                        تراکنش های کاهشی
                    </label>
                </div>
            </div>

            <div className="col-md-3 mt-4">
                <div className="mb-1">
                    <input className="form-check-input" type="checkbox" id="verifiedTransactions"
                           checked={searchForm.verifiedTransactions != undefined ? JSON.parse(searchForm.verifiedTransactions) : defaultSearchParams.verifiedTransactions}
                           onChange={() => {
                               changeSearchForm("verifiedTransactions", searchForm.verifiedTransactions != undefined ? !JSON.parse(searchForm.verifiedTransactions) : !defaultSearchParams.verifiedTransactions)
                           }}/>
                    <label className="form-check-label me-1" htmlFor="verifiedTransactions">
                        تراکنش های تایید شده
                    </label>
                </div>
                <div className="mb-1">
                    <input className="form-check-input" type="checkbox" id="unverifiedTransactions"
                           checked={searchForm.unverifiedTransactions != undefined ? JSON.parse(searchForm.unverifiedTransactions) : defaultSearchParams.unverifiedTransactions}
                           onChange={() => {
                               changeSearchForm("unverifiedTransactions", searchForm.unverifiedTransactions != undefined ? !JSON.parse(searchForm.unverifiedTransactions) : !defaultSearchParams.unverifiedTransactions)
                           }}/>
                    <label className="form-check-label me-1" htmlFor="unverifiedTransactions">
                        تراکنش های تایید نشده
                    </label>
                </div>
            </div>

            <div className="col-12">
                <button className={"btn btn-primary w-100 mt-2"} onClick={() => {
                    onSubmit(searchForm)
                }}>جست و جو
                </button>
            </div>
        </div>
    );
}

export default TransactionFilter;
